import actionTypes from '../actions/handover/actionType';

const initialState = {
  modalVisible: false,
  handoverInfoLoading: false,
  handoverInfo: {},
  amountList: [],
  baseBusinessHandoverLoading: false,
  baseBusinessIncomeList: [],
  paymentTypeList: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.TOGGLE_HANDOVER_MODAL_VISIBLE:
      const { modalVisible } = payload;
      return {
        ...state,
        modalVisible,
      };
    case actionTypes.SET_HANDOVER_INFO_LOADING:
      const { handoverInfoLoading } = payload;
      return {
        ...state,
        handoverInfoLoading,
      };
    case actionTypes.INIT_HANDOVER_INFO:
      const { handoverInfo } = payload;
      return {
        ...state,
        handoverInfo,
      };
    case actionTypes.RESET_HANDOVER_INFO:
      return {
        ...state,
        handoverInfo: {},
        amountList: [],
      };
    case actionTypes.INIT_HANDOVER_AMOUNT_LIST:
      const { amountList } = payload;
      return {
        ...state,
        amountList,
      };
    case actionTypes.UPDATE_REPORT_STATE:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.HANDOVER_BAS_BUSINESS:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.HANDOVER_MEMBER_CARD:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
